import React, { useEffect, useState, useContext } from "react";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import PersonIcon from "@material-ui/icons/Person";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import "./login.css";
import axios from "axios";
import {
  HOST_URL,
  LOCAL_STORAGE_KEY,
  basename,
  baseURL,
} from "../../../config";
import { setUserData, getUserData } from "../../common/utility/Utils";
import { CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { StoreContext } from "../../../store/Provider";
import MainLayout from "../../common/Layout/MainLayout";
import { path } from "../../../order_managment/constants/apiPath";
import NotificationManager from "react-notifications";
import instance from "../../../order_managment/common/api/interceptor";
import routeConstant from "../../../route/compoent/routeConstant";
import Blogs from "./../blogs/Blogs";
import { StoreContext as OmsStore } from "../../../order_managment/store";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
}));

const RMSLogin = (props) => {
  const classes = useStyles();
  const navigation = useNavigate();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });
  const [username, setUsername] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotLoading, setForrgotLoading] = useState(false);
  const [forgotPassView, setForgotPassView] = useState(false);
  const [userMail, setUserMail] = useState("");
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  const omscontext = useContext(OmsStore);

  const getUsersAccess = (roles) => {
    instance
      .post(`${path.USER_ACCESS}?roles=${roles}`)
      .then(async (res) => {
        if (res.Is_Success) {
          await omscontext.setUserAccess(res.data ?? {});
          setLoading(false);
          navigate(routeConstant.BLOGS);
        }
      })
      .catch((error) => {
        setLoading(false);
        navigate(routeConstant.BLOGS);
      });
  };

  const getUserDataInfo = async (token) => {
    let data = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );
    if (data?.show_orderMangement === "true") {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post(`${baseURL}${path.USER_DETAILS}`, null, { headers })
        .then((res) => {
          if (res.data.Is_Success) {
            context.setOmsUserData(res.data.data ?? {});
            getUsersAccess(res.data.data.UserRoles);
            // localStorage.setItem(
            //   LOCAL_STORAGE_KEY.user_info,
            //   JSON.stringify(res.data.data)
            // );
            setLoading(false);
            navigate(routeConstant.BLOGS);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          navigate(routeConstant.BLOGS);
          if (err.response) {
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    }
    setLoading(false);
    navigate(routeConstant.BLOGS);
  };

  const onLogin = () => {
    const emailAddress = username.trim();
    if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill User Id!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill valid User Id!");
    } else if (!values.password) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill password!");
    } else {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("username", username);
      params.append("password", values.password);
      params.append("macAddress", "");
      params.append("deviceType", "W");
      params.append("ipAddress", "");
      params.append("grant_type", "password");

      const END_POINT = `${HOST_URL}Login`;

      axios
        .post(END_POINT, params)
        .then((res) => {
          console.log({ res });
          res.data.username = username;
          res.data.password = values.password;
          console.log({ res });

          setUserData(res.data, LOCAL_STORAGE_KEY.user_token)
            .then(() => {
              context.setIsUserLogin(true);
              getUserDataInfo(res.data.access_token);
            })
            .catch(() => {
              context.setIsUserLogin(false);
              setOpenalert(true);
              setSeverity("error");
              setAlertText("Sorry! Unable to Login!");
            });
        })
        .catch((error) => {
          setLoading(false);
          context.setIsUserLogin(false);
          setOpenalert(true);
          setSeverity("error");
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            error?.response?.status === 400
              ? setAlertText(error?.response?.data?.error_description)
              : setAlertText("Something went wrong!");
          } else {
            console.log(error);
            setAlertText("Something went wrong!");
          }
        });
    }
  };

  const forgotPassword = () => {
    const emailAddress = userMail.trim();
    if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill email Id!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill valid Id!");
    } else {
      setForrgotLoading(true);
      const URL = `${baseURL}${path.FORGOTLINK}?emailId=${userMail}`;
      // const param = {
      //   user_id: userMail,
      // };
      axios
        .post(URL)
        .then((res) => {
          console.log(res);
          setForrgotLoading(false);
          setForgotPassView(false);
          if (res.data.Is_Success) {
            setOpenalert(true);
            setSeverity("success");
            setAlertText("Reset password link sent to your email...");
          } else {
            setOpenalert(true);
            setSeverity("success");
            setAlertText("Sorry! Email Id entered is not registered.");
          }
        })
        .catch((err) => {
          console.log(err);
          setForrgotLoading(false);
          setOpenalert(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="loginComponent">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      {/* <div className="loginHeader">
        <div className="loginHeadergreet">
          {forgotPassView ? (
            <span>Enter your Email Address!</span>
          ) : (
            <>
              <span>Hey, Let’s login to your account!</span>
            </>
          )}
        </div>
      </div> */}
      <div className="loginBody">
        <div className="loginFormContainer">
          <div className="loginFormContainerChild">
            {forgotPassView ? (
              <img
                src={`/${basename}/Assets/Images/forgetPassword.png`}
                alt="mtsLogo"
                className="mt-3"
              />
            ) : (
              <img
                src={`/${basename}/Assets/Images/loginImage.png`}
                className="loginImageView"
                alt="mtsLogo"
              />
            )}

            <div className="loginformBody">
              {forgotPassView ? (
                <div className="forgotPassEmailForm">
                  <div className="userId">
                    <FormControl
                      className={clsx(classes.margin, classes.textField)}
                    >
                      <TextField
                        id="standard-basic"
                        label={
                          <span className="loginLabelSpan">
                            <MailOutlineOutlinedIcon /> Email ID
                          </span>
                        }
                        value={userMail}
                        type="email"
                        onChange={(e) => {
                          setUserMail(e.target.value);
                        }}
                      />
                    </FormControl>
                  </div>
                  <div className="confirmEmail">
                    <Button
                      variant="contained"
                      onClick={() => setForgotPassView(false)}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => forgotPassword()}
                    >
                      {forgotLoading ? (
                        <CircularProgress size="1.5rem" />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="loginForm">
                  <div className="userId">
                    <FormControl
                      className={clsx(classes.margin, classes.textField)}
                    >
                      <TextField
                        id="standard-basic"
                        label={
                          <span className="loginLabelSpan">
                            <PersonIcon /> User ID
                          </span>
                        }
                        value={username}
                        type="text"
                        onChange={(e) => {
                          setUsername(e.target.value);
                        }}
                      />
                    </FormControl>
                  </div>
                  <div className="userPassword">
                    <FormControl
                      className={clsx(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="password">
                        <span className="loginLabelSpan">
                          <LockOutlinedIcon /> Password
                        </span>
                      </InputLabel>
                      <Input
                        id="password"
                        type={values.showPassword ? "text" : "password"}
                        value={values.password}
                        onChange={handleChange("password")}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                  <div className="forgotPass">
                    <span
                      onClick={() => {
                        setForgotPassView(true);
                      }}
                      className="pointer"
                    >
                      Forgot Password
                    </span>
                  </div>
                  <div className="loginButton">
                    <Button variant="contained" onClick={onLogin}>
                      {loading ? <CircularProgress size="1.5rem" /> : "Login"}
                    </Button>
                  </div>
                  <div className="scheduleSignUplinkDiv">
                    <p>
                      Don't have an account?{" "}
                      <span
                        className="pointer"
                        onClick={() => {
                          navigate(routeConstant.RMS_SIGNUP);
                        }}
                      >
                        Sign Up
                      </span>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RMSLogin;
